import React from 'react';
import { Dumbbell, Mail, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black border-t border-zinc-800 py-12 px-4" data-id="element-162">
      <div className="max-w-4xl mx-auto text-center" data-id="element-163">
        <div className="inline-flex items-center gap-2 mb-3" data-id="element-164">
          <Dumbbell className="w-5 h-5 text-primary" data-id="element-165" />
          <span className="font-space-grotesk font-extrabold text-white text-lg md:text-xl tracking-tight" data-id="element-166">
            COMPRA DIGITAL YA™
          </span>
        </div>

        <p className="text-sm md:text-base text-zinc-300 font-bold mb-2" data-id="element-167">
          El sistema N°1 para profes de Entrenamiento Funcional en Argentina.
        </p>
        <p className="text-xs md:text-sm text-zinc-500 max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-168">
          Porque dar buenas clases no debería costarte todos los domingos del
          año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-6 text-xs md:text-sm text-zinc-400 mb-8" data-id="element-169">
          <a href="mailto:compradigitalyaa@gmail.com" className="flex items-center gap-1.5 hover:text-primary transition-colors" data-id="element-170">
            <Mail className="w-3.5 h-3.5" data-id="element-171" />
            compradigitalyaa@gmail.com
          </a>
          <span className="hidden sm:inline text-zinc-700" data-id="element-172">·</span>
          <a href="https://compradigitalya.com" className="flex items-center gap-1.5 hover:text-primary transition-colors" data-id="element-173">
            <Globe className="w-3.5 h-3.5" data-id="element-174" />
            compradigitalya.com
          </a>
        </div>

        <div className="pt-6 border-t border-zinc-800/60 text-[11px] md:text-xs text-zinc-600" data-id="element-175">
          © Compra Digital Ya™ 2026 — Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}